/**
 * Lightweight auth hook for self-serve routes.
 * Self-serve pages live outside AuthProvider, so we can't use useAuth().
 * This hook calls authService.checkAuth() directly (GET /auth/me)
 * and returns the user without redirecting on failure.
 */
import { useState, useEffect } from 'react';
import authService from '@/services/authService';

export default function useSafeAuth() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    authService
      .checkAuth()
      .then((u) => {
        setUser(u);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  return { user, isAuthenticated: !!user, loading };
}
